import { Text } from "@/components/podkit/typography/Text";

export const ConversationMessageStartEnvironment = () => {
    return (
        <div data-testid="conversation-message-start-environment">
            <Text className="text-base">Please start the environment to continue.</Text>
        </div>
    );
};
